import { ComponentProps, ReactNode } from 'react'
import { To } from 'react-router-dom'
import { Link as RouterLink } from 'react-router-dom'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { AnimatePresence } from 'framer-motion'
import { PerformanceGoalsMetricRowFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { MetricRow } from '../MetricRow'

export const MetricList: React.FC<{
  metrics: PerformanceGoalsMetricRowFragment[]
  showAssignee?: boolean
  showMetricGroup?: boolean
  title?: string
  count?: number
  weight?: number
  showSeparator?: boolean
  refetchQueriesOnEdit?: ComponentProps<typeof MetricRow>['refetchQueriesOnEdit']
  to?: To
}> = ({
  metrics,
  count,
  title,
  weight,
  showAssignee,
  showMetricGroup,
  refetchQueriesOnEdit,
  to,
}) => {
  if (metrics.length === 0) return null

  const TitleWrapper: React.FC<{ children: ReactNode }> = ({ children }) =>
    to ? <RouterLink to={to}>{children}</RouterLink> : <>{children}</>

  return (
    <Box>
      {title && (
        <TitleWrapper>
          <Box flexDirection="row" gap="s8" alignItems="center">
            <Box flexGrow gap="s4">
              <Text.Header2>
                {title} {count ? `(${count})` : null}
              </Text.Header2>
              {weight != null && (
                <Text.Normal size="200" weight="semibold" color="textSecondary">
                  {i18n.t('performance_goals.weights.weight').toUpperCase()}:{' '}
                  {i18n.formatNumber(weight)}%
                </Text.Normal>
              )}
            </Box>
            {to && <Button type="secondary" aria-label={title} iconName="arrow-right" />}
          </Box>
        </TitleWrapper>
      )}

      <Box>
        <AnimatePresence initial={false}>
          {metrics.map((metric) => (
            <Box.Motion
              initial={{ opacity: 0, height: 0, overflow: 'hidden' }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0, overflow: 'hidden' }}
              key={metric.id}
              border={{ bottom: { color: 'grey200', style: 'solid', width: 's1' } }}
            >
              <Box paddingY="s16">
                <MetricRow
                  refetchQueriesOnEdit={refetchQueriesOnEdit}
                  metric={metric}
                  showAssignee={showAssignee}
                  showMetricGroup={showMetricGroup}
                />
              </Box>
            </Box.Motion>
          ))}
        </AnimatePresence>
      </Box>
    </Box>
  )
}
